// Scoped keyframes for the indeterminate bar — kept local so no shared
// stylesheet needs editing (concurrent-agent constraint).
const INDETERMINATE_KEYFRAMES = '@keyframes terms-indeterminate { 0% { transform: translateX(-100%); } 100% { transform: translateX(300%); } }';

interface BackgroundLoadingIndicatorProps {
  loadedCount: number;
}

/**
 * Thin (2px) indeterminate progress bar + caption shown while further LEK pages
 * stream in behind an already-interactive table.
 */
export const BackgroundLoadingIndicator = ({ loadedCount }: BackgroundLoadingIndicatorProps) => (
  <div aria-live="polite" className="flex flex-col gap-1" role="status">
    <style>{INDETERMINATE_KEYFRAMES}</style>
    <div className="relative h-0.5 w-full overflow-hidden rounded bg-primary/20">
      <div className="absolute inset-y-0 w-1/3 rounded bg-primary" style={{ animation: 'terms-indeterminate 1.2s ease-in-out infinite' }} />
    </div>
    <p className="text-xs text-muted-foreground">Loading additional records... ({loadedCount} loaded)</p>
  </div>
);
BackgroundLoadingIndicator.displayName = 'BackgroundLoadingIndicator';
